import { Flex, Select, TextField } from '@radix-ui/themes';
import { MonetaryValue, ValueType } from '@/lib/workflow-defs';

interface CurrencyValueInputProps {
  value: MonetaryValue;
  onChange: (value: MonetaryValue) => void;
}

const MonetaryValueInput = ({ value, onChange }: CurrencyValueInputProps) => (
  <Flex direction="row" gap="2" width="100%" style={{ maxWidth: '100%' }}>
    <TextField.Root
      type="number"
      value={value.amount}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        console.log('MonetaryValueInput.onChange', e.target.value);
        onChange({ ...value, amount: Number(e.target.value) });
      }}
      style={{ flex: 1, minWidth: 0 }}
    />
    <Select.Root
      value={value.currency}
      onValueChange={(currency: ValueType) => {
        console.log('MonetaryValueInput.onValueChange', currency);
        onChange({ ...value, currency });
      }}
    >
      <Select.Trigger style={{ width: '100px' }} />
      <Select.Content>
        {Object.values(ValueType).map((currency) => (
          <Select.Item key={currency} value={currency}>
            {currency}
          </Select.Item>
        ))}
      </Select.Content>
    </Select.Root>
  </Flex>
);

export default MonetaryValueInput;
